import { render } from 'preact';
import './tokens.css';
import { App } from './App';
import { seedIfEmpty } from '../data/seeds';
import { refreshCore, toast } from './state';
import { refreshUsage } from '../ai/client';
import { processOutbox } from '../ai/outbox';
import { getSettings, explainStorageError } from '../core/db';

async function boot(): Promise<void> {
  const el = document.getElementById('app')!;
  try {
    await seedIfEmpty();
    // ask the browser not to evict our data (best effort; status shown in Settings)
    try { await navigator.storage?.persist?.(); } catch { /* unsupported is fine */ }
    await refreshCore();
    void refreshUsage(); // fire-and-forget: the chip appears when the proxy answers
    render(<App />, el);
    // offline outbox: drain on boot and whenever the connection returns (§5.8)
    const drain = async () => { void processOutbox((await getSettings()).currentUser); };
    void drain();
    window.addEventListener('online', () => { void drain(); });
    window.addEventListener('unhandledrejection', (ev) => {
      const plain = explainStorageError(ev.reason);
      if (plain) { ev.preventDefault(); toast(plain); }
    });
    if (import.meta.env.PROD && 'serviceWorker' in navigator) {
      navigator.serviceWorker.register('/sw.js').catch(() => { /* app works without it; offline shell degrades */ });
    }
  } catch (err) {
    el.innerHTML = `
      <div style="max-width:560px;margin:80px auto;font-family:system-ui;padding:0 20px;">
        <h1 style="font-size:22px;">The app could not start</h1>
        <p style="margin:12px 0;">Something went wrong while opening the local database. Your data is not gone —
        the most common cause is private-browsing mode, which blocks storage.</p>
        <p style="margin:12px 0;"><b>Try:</b> open this page in a normal (not private) window, or a different browser.
        If it keeps happening, your latest export file restores everything on any device.</p>
        <p style="color:#777;font-size:13px;">Technical detail: ${String((err as Error)?.message ?? err).replace(/[<>&]/g, '')}</p>
      </div>`;
  }
}

void boot();
